/**
 * syncOpen — re-point an open detail modal at its own refreshed row.
 *
 * Every CRM list captures the clicked row object into state (`setOpen(row)`) and hands that exact
 * object to the detail modal. Refreshing the list afterwards replaced the ARRAY but never that
 * captured object, so the open modal — and any editor it opens — kept rendering the snapshot from
 * before the save. That is what made saved edits look reverted until a full page reload, and (with
 * an editor that wrote its whole field set on save) what let a stale value overwrite a newer one.
 *
 * Use it as the state updater wherever a list is refreshed:
 *
 *   getProposals().then(list => { setProps(list); setOpen(syncOpen(list)) })
 *
 * Keeps the current value when the row is gone from the refreshed list (deleted, or filtered out)
 * rather than blanking the modal out from under whoever is reading it, and passes through the
 * `null`/`undefined` sentinels these views use for "closed" / "creating new".
 */
export function syncOpen(list) {
  return cur => {
    if (!cur || !cur.id || !Array.isArray(list)) return cur
    return list.find(r => r && r.id === cur.id) || cur
  }
}
